import { Component, OnInit, Input, AfterContentChecked } from '@angular/core';
import { SpinnerService } from '../../shared-components/spinner/spinner.service';

@Component({
  selector: 'app-helpbutton-reports-card',
  templateUrl: './helpbutton-reports-card.component.html',
  styleUrls: ['./helpbutton-reports-card.component.scss']
})
export class HelpbuttonReportsCardComponent implements OnInit, AfterContentChecked {

  @Input() data;
  count;
  showCounter: boolean;

  constructor(private spinnerService: SpinnerService) { }

  ngOnInit() { }

  ngAfterContentChecked() {
    this.spinnerService.show('reports-counts-spinner');
    if ((null !== this.data) && (undefined !== this.data) && ('-' !== this.data)) {
      this.spinnerService.hide('reports-counts-spinner');
      this.showCounter = true;
      this.count = this.data;
    } else if ('-' === this.data) {
      this.count = '-';
      this.showCounter = true;
    }
  }

}
